/**
 * Пресеты правил Vuelidate для часто используемых полей форм
 */
import { helpers, required } from '@vuelidate/validators';

import { validationMessages, withMessage } from './messages';
import { isValidInternationalPhone } from './phone-validators';

/**
 * Правила валидации телефона: обязательное + международный формат
 */
export const phoneRules = {
  required: withMessage(validationMessages.required, required),
  validPhone: withMessage(
    validationMessages.phone,
    helpers.withParams({ type: 'validPhone' }, (value: string) => {
      if (!value) return true; // обрабатывается правилом required
      return isValidInternationalPhone(value);
    }),
  ),
};

/**
 * Правила валидации обязательного поля
 */
export const requiredRule = {
  required: withMessage(validationMessages.required, required),
};
